export function getFavoritesSideRailCandidateIds(favoriteIds: string[], retainedFavoriteId: string | undefined, maxFavorites: number): string[] {
    const candidateIds = favoriteIds.slice(0, maxFavorites);
    if (retainedFavoriteId &&
        favoriteIds.includes(retainedFavoriteId) &&
        !candidateIds.includes(retainedFavoriteId)) {
        candidateIds.push(retainedFavoriteId);
    }
    return candidateIds;
}

export function getVisibleFavoritesSideRailIds(candidateIds: string[], retainedFavoriteId: string | undefined, itemHeights: ReadonlyMap<string, number>, maxHeight: number, itemGap: number): string[] | undefined {
    if (maxHeight <= 0) {
        return [];
    }
    
    let totalHeight = 0;
    const visibleIds: string[] = [];
    for (const favoriteId of candidateIds) {
        const itemHeight = itemHeights.get(favoriteId);
        if (itemHeight === undefined) {
            return undefined;
        }
        
        const slotHeight = itemHeight + (visibleIds.length > 0 ? itemGap : 0);
        if (totalHeight + slotHeight > maxHeight) {
            break;
        }
        
        totalHeight += slotHeight;
        visibleIds.push(favoriteId);
    }
    
    if (!retainedFavoriteId ||
        visibleIds.includes(retainedFavoriteId) ||
        !candidateIds.includes(retainedFavoriteId)) {
        return visibleIds;
    }
    
    const retainedItemHeight = itemHeights.get(retainedFavoriteId);
    if (retainedItemHeight === undefined) {
        return undefined;
    }
    
    if (retainedItemHeight > maxHeight) {
        return [];
    }
    
    while (visibleIds.length > 0 && totalHeight + itemGap + retainedItemHeight > maxHeight) {
        const removedFavoriteId = visibleIds.pop();
        if (!removedFavoriteId) {
            break;
        }
        
        const removedItemHeight = itemHeights.get(removedFavoriteId);
        if (removedItemHeight === undefined) {
            return undefined;
        }
        
        totalHeight -= removedItemHeight;
        if (visibleIds.length > 0) {
            totalHeight -= itemGap;
        }
    }
    
    return [...visibleIds, retainedFavoriteId];
}
